import { GroupErrorReportResponse } from 'src/app/core/models/reports/error-reports.model';

export const GROUP_ERROR_CONSTS = {
  HEADER: $localize`Group Error Report`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
};

export const FILE_NAME = 'Group-Error-Report';

export const GROUP_ERROR_PDF_REPORT = {
  NAME: 'Group Error Report',
  COLUMNS: [
    'Timestamp'.toUpperCase(),
    'Location'.toUpperCase(),
    'Loop'.toUpperCase(),
    'ErrorMessage'.toUpperCase(),
    'DeviceName'.toUpperCase(),
    'TrackNo'.toUpperCase(),
    'ScanCode'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'timestamp',
    'location',
    'loop',
    'errorMessage',
    'deviceName',
    'trackNo',
    'scanCode',
  ] as (keyof GroupErrorReportResponse)[],
};
